import React, {Component} from 'react';
import API from '../services/API';
import LogoPic from "../assets/images/ic_logo.png";

class Splash extends Component {
    render() {
        return (
            <section className="container bg-blue min-vh-100">
                <div className="row text-center">
                    <div className="col-12 pt-5">
                        <img src={LogoPic} alt="بارسپار" className="rounded mx-auto d-block mt-5 w-50  "/>
                    </div>
                    <h2 className="col-12 text-center mt-4 header-text text-white">
                        گوهر زمین توس
                    </h2>
                    <h6 className="col-12 text-center mt-4 text-warning">
                        سامانه هوشمند حمل و نقل بین شهری
                    </h6>
                    <div className="col-12 text-center fixed-bottom mb-3">
                        <div className="spinner-grow header-text" role="status">

                        </div>
                    </div>
                </div>
            </section>
        );
    }

    componentDidMount = () => {

        API.start()
            .then((response) => {

                const userLogin = response.results.user_login;

                setTimeout(() => {
                    userLogin ? this.props.history.push("/home/1") : this.props.history.push("/login");
                }, 2000);
            })

        window.localStorage.removeItem("status_id")
        window.localStorage.removeItem("date_from")
        window.localStorage.removeItem("date_to")
        window.localStorage.removeItem("company_name")
    }
}

export default Splash;